import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "las la-check"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_highlight_region = _resolveComponent("highlight-region")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dataType === 'string' || _ctx.dataType === 'number')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.filter && _ctx.filter.length > 0)
            ? (_openBlock(), _createBlock(_component_highlight_region, {
                key: 0,
                text: typeof _ctx.data === 'string' ? _ctx.data.toString() : '',
                filter: _ctx.filter,
                "word-wrap": _ctx.wordWrap
              }, null, 8, ["text", "filter", "word-wrap"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.data?.toString()), 1)
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'time')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.filter && _ctx.filter.length > 0)
            ? (_openBlock(), _createBlock(_component_highlight_region, {
                key: 0,
                text: _ctx.renderTime(_ctx.data),
                filter: _ctx.filter,
                "word-wrap": _ctx.wordWrap
              }, null, 8, ["text", "filter", "word-wrap"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.renderTime(_ctx.data)), 1)
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'boolean')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.renderBoolean(_ctx.data))
            ? (_openBlock(), _createElementBlock("i", _hoisted_1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'date')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createTextVNode(_toDisplayString(_ctx.renderDate(_ctx.data)), 1)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}